export default __webpack_public_path__ + "static/media/ic_more.93b61377.svg";